import { Brand } from './branded-type';

/**
 * The ValueObject class is an abstract base class for creating value objects
 * in a domain-driven design context. A value object is characterized by its
 * attributes and is immutable.
 *
 * @template T - Represents the primitive type of the value the object holds.
 * @template K - A unique symbol or type used to create a branded type, ensuring type safety.
 */
export abstract class ValueObject<T, K> {
  protected readonly _value: Brand<K, T>;

  protected constructor(value: T) {
    this._value = value as Brand<K, T>;
  }

  public get value(): Brand<K, T> {
    return this._value;
  }

  public equals(vo?: ValueObject<T, K>): boolean {
    if (vo === null || vo === undefined) {
      return false;
    }
    return this._value === vo._value;
  }
}
